/**
 * SHARED LEGACY FILE
 *
 * These error utilities are used by multiple apps split from LearningCenterUI.
 * They do not belong to any single app — each app that needs them
 * imports this shared copy.
 *
 * The .legacy suffix exists to preserve git history transfer.
 */

import I18n from 'I18n';
import PortalIdParser from 'PortalIdParser';
import Raven from 'raven-js';
const sendToLogFetch = ({
  loggingTitle,
  errorMessage,
  additionalData
}) => Raven.captureMessage(loggingTitle, {
  extra: Object.assign({
    errorMessage
  }, additionalData),
  tags: Object.assign({}, PortalIdParser.get() && {
    hubId: `${PortalIdParser.get()}`
  })
});
export const handleApolloErrors = ({
  additionalData,
  loggingTitle
}) => {
  const errorTitle = I18n.text(loggingTitle, {
    locale: 'en'
  });
  sendToLogFetch({
    loggingTitle: errorTitle,
    additionalData
  });
};